import type { ReactNode, FC } from 'react';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import PlaygroundTabs from '../PlaygroundTabs';
import s from './PlaygroundEmptyStateMobile.scss';

interface Props {
  heading: ReactNode;
  description: ReactNode;
  callToAction?: ReactNode;
  postfix?: ReactNode;
}

const PlaygroundEmptyStateMobile: FC<Props> = ({
  heading,
  description,
  callToAction,
  postfix,
}) => {
  return (
    <>
      <PlaygroundTabs />
      <Section className={s['root']}>
        <div className={s['text-section']}>
          <Heading className={s['heading']}>{heading}</Heading>
          <p className={s['description']}>{description}</p>
        </div>
        {callToAction && <span>{callToAction}</span>}
        {postfix}
      </Section>
    </>
  );
};

PlaygroundEmptyStateMobile.displayName = 'PlaygroundEmptyStateMobile';

export default PlaygroundEmptyStateMobile;
